export const projects = [
  {
    title: "Ecommerce Store",
    subtitle: ".Net and React",
    description:
      "Built a full stack E-commerce web store using .Net and React",
    image: "./project2.gif",
    link: "https://e-commerce-retail.herokuapp.com/catalog",
  },
  {
    title: "Cryptocurrency Dashboard",
    subtitle: "React",
    description:
      "Built a dashboard to view realtime price actions and charts of top Cryptocurrencies using React",
    image: "./project3.gif",
    link: "https://crypto-dashboard-app.web.app/",
  },
  {
    title: "Ping Messenger",
    subtitle: "React and Firebase",
    description:
      "Creating a complete live chat application with React, Redux, and Firebase from scratch.",
    image: "./project1.gif",
    link: "https://react-slack-clone-84e1d.web.app",
  },
];

export const RPAprojects = [
  {
    title: "LinkedIn Bot for Recruiters",
    subtitle: ".Net and Pega RPA",
    description:
      "RPA bot to assist recruiters find potential job applicants by scraping data from linkedIn and emailing the recruiters the excel file of the applicants along with pdf of their resume/cv",
    image: "./project4.gif",
    link: "https://github.com/shanegracias7/LinkedInBot",
  },
  {
    title: "Series of RPA bot",
    subtitle: "UiPath",
    description:
      "Developed series of bots to perform Web data entry, Web data scraping ,Email automation, OCR data scraping, PDF data scraping, Storing outputs in excel, automating windows application.",
    image: "./project5.gif",
    link: "https://github.com/shanegracias7/UiPath",
  }
];



export const skills = [
  "React",
  "JavaScript",
  "SQL",
  ".NET",
  "C#",
  "UiPath",
  "Pega RPA"
];
